import { useEffect, useState } from 'react'

import { fetchLicence, NO_EVALUATION } from '../config/licence'

// Finche' la risposta non arriva vale NO_EVALUATION: il modulo resta usabile,
// perche' il backend rifiuta comunque il login se la valutazione e' scaduta.
// Il setter serve a chi riceve quel rifiuto e vuole mostrarlo nel banner.
const useLicence = () => {
  const [licence, setLicence] = useState(NO_EVALUATION)

  useEffect(() => {
    let active = true
    fetchLicence().then((status) => {
      if (active) setLicence(status)
    })
    return () => {
      active = false
    }
  }, [])

  return [licence, setLicence]
}

export default useLicence
